import { createUrl, restGet } from '~/src/dash/api/rest';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

interface IContextualSegmentOptionsPromise {
  ContextualSegments: ISelectOption[];
  success: boolean;
}

export async function fetchContextualSegmentOptions(
  publisherID: string,
): Promise<IContextualSegmentOptionsPromise> {
  const reqUrl = createUrl('/contextual_segment_options', publisherID, 'v1');
  const response = await restGet<any>(reqUrl, {});
  return response.parsedBody;
}

// this wrapper allows it to be used in the current format
export const generateContextualSegmentOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  const shouldMaskLabel = checkUserInfoMasked(user.user);
  return fetchContextualSegmentOptions(session.publisher.ID)
    .then(({ ContextualSegments }) => {
      if (shouldMaskLabel) {
        ContextualSegments.forEach((segment) => {
          segment.label = `demo_contextual_segment_${segment.id}`;
        });
      }
      return ContextualSegments || [];
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
